import { useMutation, useQueryClient } from "@tanstack/react-query";
import scenarioRepository from "@/repository/scenarioRepository";
import { scenarioQueryKeys } from "./keys";


export const useDeleteScenario = (id: string) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ['scenario', "delete"],
        mutationFn: async () => {
            const data = await scenarioRepository.delete(id);
            return data;
        },
        onSuccess: async () => {
            await Promise.all([
                queryClient.refetchQueries({ queryKey: scenarioQueryKeys.pageAll() }),
                queryClient.refetchQueries({ queryKey: scenarioQueryKeys.recent() })
            ]);
        }
    });
};
